import {
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from "./ui/accordion";
import { Reveal } from "./motion";

const FAQS = [
  {
    q: "How do I book a class?",
    a: "Just fill out the training request form on our Courses page. Tell us the course, how many people need training, and your preferred date — a member of Second Chance CPR will reach out to you by email to confirm the details.",
  },
  {
    q: "Do you offer group and on-site training?",
    a: "Yes. We provide both individual and group classes, and we can arrange training for your business, school, church, daycare, or community organization throughout Missouri.",
  },
  {
    q: "Which courses do you teach?",
    a: "We offer Basic CPR, AED Training, First Aid, and Basic Life Support (BLS). BLS is designed for healthcare professionals and others who require advanced CPR skills for the workplace.",
  },
  {
    q: "Where do you provide training?",
    a: "Second Chance CPR is Missouri-based and serves communities throughout Missouri. Scheduling is flexible and arranged around your needs.",
  },
  {
    q: "How much does a class cost?",
    a: "Pricing depends on the course, group size, and location. Send us your details through the request form and we'll follow up by email with everything you need to know.",
  },
  {
    q: "What happens after I submit the form?",
    a: "Someone from our team will reach out to you by email to confirm your class, answer any questions, and finalize your training date. It's that simple.",
  },
];

export const FAQ = () => {
  return (
    <section className="py-24 lg:py-28 bg-[#D1FAE5]/40 border-y border-emerald-100" data-testid="faq-section">
      <div className="mx-auto max-w-4xl px-6 lg:px-10">
        <Reveal>
          <div className="text-left">
            <span className="font-grotesk text-sm uppercase tracking-[0.2em] text-teal">
              FAQ
            </span>
            <h2 className="mt-4 font-editorial font-black text-navy tracking-tight leading-[1.03] text-4xl sm:text-5xl">
              Questions, answered
            </h2>
            <p className="mt-5 max-w-2xl font-body text-lg text-slate-600 leading-relaxed">
              Everything you need to know before you book. Still curious?
              Submit the form and someone will reach out to you.
            </p>
          </div>
        </Reveal>

        <Reveal delay={0.1}>
          <Accordion
            type="single"
            collapsible
            className="mt-10 rounded-3xl bg-white border border-slate-200 px-6 sm:px-8 ambient-shadow"
          >
            {FAQS.map((item, i) => (
              <AccordionItem
                key={i}
                value={`faq-${i}`}
                className="border-slate-200"
                data-testid={`faq-item-${i}`}
              >
                <AccordionTrigger className="py-6 text-lg font-grotesk font-bold text-navy hover:no-underline">
                  {item.q}
                </AccordionTrigger>
                <AccordionContent className="pb-6 font-body text-[15px] leading-relaxed text-slate-600">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
};
